import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SnackErrorComponent, SnackSuccessComponent } from '@pcscol-portail/composants-pegase';
import { tap } from 'rxjs/operators';
import { AppActions } from './app.actions';

const downloadLink = document.createElement('a');

function getNestedErrorIfExist(error: HttpErrorResponse): HttpErrorResponse {
  if (
    ((error.status >= 500 && error.status <= 599) ||
      (error.status >= 400 && error.status <= 403)) &&
    error.error
  ) {
    const rebrandError = { ...error.error, causes: error.error.errors };
    if (!rebrandError.message) {
      rebrandError.message = error.message;
    }
    return rebrandError;
  }
  return error;
}

function getNicerErrorMessage(error: HttpErrorResponse): HttpErrorResponse {
  if (error.status === 0) {
    return {
      ...error,
      message: 'Serveur indisponible',
    };
  }
  if (!error.message && error?.error?.message) {
    return {
      ...error,
      message: error.error.message,
    };
  }
  return error;
}

export const appDisplayError$ = createEffect(
  (actions$ = inject(Actions), snackBar = inject(MatSnackBar)) =>
    actions$.pipe(
      ofType(AppActions.displayError),
      tap((action) =>
        SnackErrorComponent.open(
          snackBar,
          getNicerErrorMessage(getNestedErrorIfExist(action.payload)),
        ),
      ),
    ),
  { functional: true, dispatch: false },
);

export const appDisplaySuccessMessage$ = createEffect(
  (actions$ = inject(Actions), snackBar = inject(MatSnackBar)) =>
    actions$.pipe(
      ofType(AppActions.displaySuccessMessage),
      tap((action) => SnackSuccessComponent.open(snackBar, action.payload)),
    ),
  { functional: true, dispatch: false },
);

export const downloadBlob$ = createEffect(
  (actions$ = inject(Actions)) =>
    actions$.pipe(
      ofType(AppActions.downloadBlob),
      tap((action) => {
        const data = window.URL.createObjectURL(action.blob);

        downloadLink.href = data;
        downloadLink.download = action.fileName;

        downloadLink.dispatchEvent(
          new MouseEvent('click', { bubbles: true, cancelable: true, view: window }),
        );

        window.URL.revokeObjectURL(data);
        downloadLink.remove();
      }),
    ),
  { functional: true, dispatch: false },
);
